
import React, { Component } from "react";
import { Row } from "react-flexbox-grid";
import Repeat from "react-repeat-component";

class UserProfileDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userdata: this.props.userdata,
      id: this.props.id,
      attended_events: [],
      registered_events: [],
    };
  }

  componentDidMount() {
    this.props.userdata.hasOwnProperty("attended_events")
      ? this.props.userdata.attended_events.map((event) =>
          event.get().then((doc) => {
            let data = doc.data();
            let { attended_events } = this.state;
            attended_events.push(data);
            this.setState({ attended_events: attended_events });
          })
        )
      : console.log("no events attended");

    this.props.userdata.hasOwnProperty("registered_events")
      ? this.props.userdata.registered_events.map((event) =>
          event.get().then((doc) => {
            let data = doc.data();
            let { registered_events } = this.state;
            registered_events.push(data);
            this.setState({ registered_events: registered_events });
          })
        )
      : console.log("no events registered");
  }
  render() {
    const {attended_events, registered_events} = this.state; 

    return attended_events.length === 0 || registered_events.length === 0 ? (
      <Row>Loading...</Row>
    ) : (
      <React.Fragment>
        <Row>
          <fieldset className="field-style">
            <legend>General User Data</legend>
            {this.renderUserDate()}
          </fieldset>
        </Row>
        <Row>{this.renderEventsData()}</Row>
        <Row>{this.renderHistoricalData()}</Row>
      </React.Fragment>
    );
  }

  getDate = (event_dates) => {
    let s_date = [];

    for (let i = 0; i < event_dates.length; i++) {
      s_date.push(event_dates[i].date.toDate().toDateString());
    }

    return s_date;
  };

  renderEventsData = () => {
    let { registered_events, attended_events } = this.state;

    return (
      <div>
        <fieldset className="field-style">
          <legend>Registered events</legend>
          {registered_events.map((item, index) => {

            
            return !item ? (
              <div>
                <strong>oops this event doesn't exists... </strong>
              </div>
            ) : (
              <div>
                <li key={index}>
                  <strong> Event Name: </strong>
                  {item.event_name_ar},
                  <ol>
                    <strong> Event Date: </strong>
                    {this.getDate(item.event_date).map((item) => (
                      <li>{item + ", "}</li>
                    ))}
                  </ol>
                </li>
              </div>
            );
          })}
        </fieldset>
        <fieldset className="field-style">
          <legend>Attended events</legend>
          {attended_events.map((item, index) => {
            return !item ? (
              <div>  <strong>oops this event doesn't exists...  </strong></div>
            ) : (
              <div>
                <li key={index}>
                  <strong> Event Name: </strong>
                  {item.event_name_ar},
                  <ol>
                    <strong> Event Date: </strong>
                    {this.getDate(item.event_date).map((item) => (
                      <li>{item + ", "}</li>
                    ))}
                  </ol>
                </li>
              </div>
            );
          })}
        </fieldset>
      </div>
    );
  };

  renderHistoricalData = () => {
    let keys = [
      "rowad",
      "requestMatching",
      "teams",
      "success_stories",
      "consultations",
    ];
    let userdata = this.state.userdata;
    console.log(userdata);
    return (
      <Row>
        {
          <fieldset className="field-style">
            <legend>Data on Other Programs</legend>
            <Repeat times={keys.length}>
              {(i) => {
                //console.log(userdata);
                if (userdata.hasOwnProperty(keys[i])) {
                  if (keys[i] === "rowad") {
                    return (
                      <div>
                        <h4> Ruwad</h4>
                        <li>
                          Application Type:{" "}
                          {userdata[keys[i]].type_of_application}{" "}
                        </li>
                        <li>Application Status: {userdata[keys[i]].status}</li>
                      </div>
                    );
                  }
                  if (keys[i] === "requestMatching") {
                    return (
                      <div>
                        <h4> Tech X Entreprenuer Matching</h4>
                        <li>
                          Application Type: {userdata[keys[i]].type_of_request}{" "}
                        </li>
                        <li>Application Status: {userdata[keys[i]].status}</li>
                      </div>
                    );
                  }
                  if (keys[i] === "teams") {
                    return (
                      <div>
                        <h4>Applied to Challenges</h4>
                        number of challenages:
                        {Object.keys(userdata[keys[i]]).length}
                      </div>
                    );
                  }
                  return (
                    <div>
                      <h4>Applied to {keys[i].replace("_", " ")}</h4>
                      number of {keys[i].replace("_", " ")}:
                      {userdata[keys[i]].length}
                    </div>
                  );
                }
              }}
            </Repeat>
          </fieldset>
        }
      </Row>
    );
  };

  renderUserDate = () => {
    let titles = [
      "First Name",
      "Family Name",
      "Phone",
      "Email",
      "Gender",
      "User type",
      "Sector",
      "Size",
      "Revenue",
      "Facility Name",
      "Tell us more",
    ];
    let keys = [
      "firstname",
      "familyname",
      "phone",
      "email",
      "gender",
      "user_type",
      "sector",
      "size",
      "revenue",
      "facility_name",
      "tell_us_more",
    ];

    return (
      <table>
        {
          <Repeat times={keys.length}>
            {(i) =>
              typeof this.state.userdata[keys[i]] === "object" ? (
                <tr key={i}>
                  <td>
                    <strong>{titles[i]}:</strong>
                  </td>
                  <td>
                    {this.state.userdata[keys[i]].map((item, index) => (
                      <li key={index}> {item} </li>
                    ))}
                  </td>
                </tr>
              ) : (
                <tr key={i}>
                  <td>
                    <strong>{titles[i]}:</strong>
                  </td>
                  <td>{this.state.userdata[keys[i]]}</td>
                </tr>
              )
            }
          </Repeat>
        }
      </table>
    );
  };
}


export default UserProfileDate;
